module.exports = __webpack_public_path__ + "img/submit.f84bb311.png";